// extracted by mini-css-extract-plugin
export var bodySections = "_bh-8";
export var gray = "_bh-7";
export var green = "_bh-4";
export var iconContainer = "_bh-9";
export var iconWidgetContainer = "_bh-1";
export var phoneIcon = "_bh-2";
export var red = "_bh-5";
export var statusDot = "_bh-3";
export var widgetContainer = "_bh-0";
export var yellow = "_bh-6";